import API from "../../services/api";
import {
  asArray,
  normalizeEmployeeListResponse,
  normalizeRosterValidation,
} from "./rosterSafeArrays";

export async function searchEmployees({ search = "", page = 1, pageSize = 50, activeOnly = true }) {
  const res = await API.get("/employees/", {
    params: {
      search: search || undefined,
      page,
      page_size: pageSize,
      active_only: activeOnly,
    },
  });
  return normalizeEmployeeListResponse(res.data);
}

export async function fetchWfShifts() {
  const res = await API.get("/wf/shifts");
  return asArray(res.data?.items ?? res.data);
}

export async function fetchWfRosters() {
  const res = await API.get("/wf/rosters");
  return asArray(res.data);
}

export async function createWfRoster(data) {
  const res = await API.post("/wf/rosters", data);
  return res.data;
}

export async function updateWfRoster(rosterPlanId, data) {
  const res = await API.patch(`/wf/rosters/${rosterPlanId}`, data);
  return res.data;
}

export async function deleteWfRoster(rosterPlanId) {
  await API.delete(`/wf/rosters/${rosterPlanId}`);
}

export async function fetchRosterAssignmentsGrid(rosterPlanId) {
  const res = await API.get(`/wf/rosters/${rosterPlanId}/assignments/grid`);
  return asArray(res.data);
}

export async function addWfRosterAssignments(rosterPlanId, assignments, adminOverride = false) {
  const body = {
    assignments,
    admin_override: Boolean(adminOverride),
  };
  try {
    const res = await API.post(`/wf/rosters/${rosterPlanId}/assignments`, body);
    return res.data;
  } catch (error) {
    console.error("Assignment API error", error.response?.status, error.response?.data);
    throw error;
  }
}

export async function updateRosterAssignment(rosterPlanId, assignmentId, data) {
  const res = await API.patch(`/wf/rosters/${rosterPlanId}/assignments/${assignmentId}`, data);
  return res.data;
}

export async function deleteRosterAssignment(rosterPlanId, assignmentId, adminOverride = false) {
  await API.delete(`/wf/rosters/${rosterPlanId}/assignments/${assignmentId}`, {
    params: { admin_override: adminOverride },
  });
}

export async function bulkCopyRosterAssignments(rosterPlanId, payload) {
  const res = await API.post(`/wf/rosters/${rosterPlanId}/assignments/bulk-copy`, payload);
  return res.data;
}

export async function fetchRosterAssignmentAudit(rosterPlanId, limit = 100) {
  const res = await API.get(`/wf/rosters/${rosterPlanId}/assignments/audit`, { params: { limit } });
  return asArray(res.data);
}

export async function fetchRosterStateLog(rosterPlanId) {
  const res = await API.get(`/wf/enterprise/rosters/${rosterPlanId}/state-log`);
  return asArray(res.data);
}

export async function publishWfRoster(rosterPlanId) {
  const res = await API.post(`/wf/rosters/${rosterPlanId}/publish`);
  return res.data;
}

export async function submitWfRoster(rosterPlanId, notes) {
  const res = await API.post(`/wf/enterprise/rosters/${rosterPlanId}/submit`, { notes });
  return res.data;
}

export async function approveWfRoster(rosterPlanId) {
  const res = await API.post(`/wf/enterprise/rosters/${rosterPlanId}/approve`);
  return res.data;
}

export async function freezeWfRoster(rosterPlanId) {
  const res = await API.post(`/wf/enterprise/rosters/${rosterPlanId}/freeze`);
  return res.data;
}

export async function archiveWfRoster(rosterPlanId) {
  const res = await API.post(`/wf/enterprise/rosters/${rosterPlanId}/archive`);
  return res.data;
}

export async function adminReopenRoster(rosterPlanId, overrideReason) {
  const res = await API.post(`/wf/enterprise/rosters/${rosterPlanId}/admin-reopen`, {
    override_reason: overrideReason,
    target_status: "draft",
  });
  return res.data;
}

export async function fetchWfHolidaysForRange(fromDate, toDate) {
  const res = await API.get("/wf/holidays", { params: { from_date: fromDate, to_date: toDate } });
  return asArray(res.data);
}

export async function validateRosterPlan(rosterPlanId) {
  const res = await API.get(`/wf/rosters/${rosterPlanId}/validate`);
  return normalizeRosterValidation(res.data);
}
